import React from "react";
import { Plus, Search } from "lucide-react";

interface GroupsHeaderProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onAddGroup: () => void;
  groupsCount?: number;
}

const GroupsHeader: React.FC<GroupsHeaderProps> = ({
  searchTerm,
  setSearchTerm,
  onAddGroup,
  groupsCount,
}) => {
  return (
    <div className="bg-white shadow rounded-lg p-6 mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Groups</h1>
          <p className="text-gray-600 mt-1">
            Manage your email recipient groups ({groupsCount} total)
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          {/* Search Input */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
            <input
              type="text"
              placeholder="Search groups..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full sm:w-64"
            />
          </div>

          {/* Create Group Button */}
          <button
            onClick={onAddGroup}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Plus className="h-4 w-4" />
            Create Group
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupsHeader;
